import fr, { TranslationFr } from '@/translations/messages.fr'
import en, { TranslationEn } from '@/translations/messages.en'

export type LanguageKey = TranslationEn & TranslationFr

const messages = { en, fr }

export default messages
